import { Eye, Target, Heart, Star, Shield, Lightbulb, Lock, Handshake } from "lucide-react";

const valores = [
  { icon: Handshake, label: "Compromiso" },
  { icon: Star, label: "Calidad" },
  { icon: Shield, label: "Confianza" },
  { icon: Lightbulb, label: "Innovación" },
  { icon: Lock, label: "Seguridad" },
];

const pilares = [
  {
    icon: Eye,
    title: "Visión",
    text: "Ser referentes regionales para el año 2027 en la entrega de obras y servicios que superen las expectativas del cliente, destacando por nuestra capacidad técnica y cumplimiento.",
  },
  {
    icon: Target,
    title: "Misión",
    text: "Brindar soluciones en obras y servicios integrales que respondan a los requisitos de nuestros clientes de forma segura y sostenible.",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-slate-900 py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-500 text-xs font-bold uppercase tracking-[0.25em] mb-3">
            Nosotros
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-6">
            Conectamos infraestructura{" "}
            <span className="text-amber-500">con experiencia</span>
          </h2>
          <p className="text-slate-400 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
            Combinamos <strong className="text-white">18 años de trayectoria</strong> con
            tecnología de vanguardia y un equipo profesional altamente capacitado. Acompañamos a
            empresas e industrias en el desarrollo de proyectos técnicos duraderos y seguros, bajo
            estrictos estándares de calidad.
          </p>
        </div>

        {/* Visión y Misión */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          {pilares.map((pilar) => {
            const Icon = pilar.icon;
            return (
              <div key={pilar.title} className="flex flex-col items-center text-center group">
                <div className="relative mb-6">
                  <div className="w-24 h-24 rounded-full border-2 border-dashed border-amber-500/50 flex items-center justify-center bg-amber-500/10 group-hover:bg-amber-500/20 group-hover:border-amber-500 transition-all duration-300">
                    <Icon className="text-amber-500" size={36} strokeWidth={1.5} />
                  </div>
                </div>
                <h3 className="text-white font-bold text-xl mb-3">{pilar.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed max-w-md">
                  {pilar.text}
                </p>
              </div>
            );
          })}
        </div>

        {/* Valores */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-full border-2 border-dashed border-amber-500/50 flex items-center justify-center bg-amber-500/10">
              <Heart className="text-amber-500" size={18} strokeWidth={1.5} />
            </div>
            <h3 className="text-white font-bold text-xl">Nuestros Valores</h3>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
          {valores.map((valor) => {
            const Icon = valor.icon;
            return (
              <div
                key={valor.label}
                className="flex flex-col items-center text-center group"
              >
                <div className="w-20 h-20 rounded-full border-2 border-dashed border-amber-500/50 flex items-center justify-center bg-amber-500/10 group-hover:bg-amber-500/20 group-hover:border-amber-500 transition-all duration-300 mb-4">
                  <Icon className="text-amber-500" size={28} strokeWidth={1.5} />
                </div>
                <span className="text-slate-300 text-sm font-semibold">{valor.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
